import type { HTTPMethod } from '@warp-drive/core-types/request';

import ApplicationAdapter from 'webapp/adapters/application';

export default class TemplateAdapter extends ApplicationAdapter {
	override ajaxOptions(url: string, type: HTTPMethod, options: JQueryAjaxSettings | RequestInit) {
		const hash = super.ajaxOptions(url, type, options);
		(hash as JQueryAjaxSettings).timeout = 1 * 60 * 1000; // 1min
		return hash;
	}
}
